import React, { useState, useEffect } from 'react';
import styles from './Product.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useParams } from "react-router-dom";
import { allProducts } from '../API/ProductsAPI';
import Tabs from './ProductDetails/Tabs/Tabs';
import useTabTitle from '../Hooks/useTabTitle';
import { useNavigate } from "react-router-dom";
import RecentProducts from './../RecentProducts/RecentProducts';
import TopBar from './TopBar/TopBar';
import ClientBanner from '../ClientBanner/ClientBanner';
import { useSwipeable } from "react-swipeable";

const ProductPage = (props) => {
    const navigate = useNavigate();

    const { productId } = useParams();
    const isValidProductId = Number.isInteger(Number(productId));
    const product = isValidProductId
        ? allProducts.find((product) => product.id === Number(productId))
        : null;

    const setTabTitle = useTabTitle(product ? product.name : "Produs invalid")

    const [currentImage, setCurrentImage] = useState(0);
    const [priceIndex, setPriceIndex] = useState(0);

    const handlePrevious = () => {
        setCurrentImage((prev) => (prev === 0 ? product.images.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentImage((prev) => (prev === product.images.length - 1 ? 0 : prev + 1));
    };

    // Folosește `useSwipeable` pentru a detecta swipe-urile
    const handlers = useSwipeable({
        onSwipedLeft: handleNext, // Swipe spre stânga => mută la dreapta
        onSwipedRight: handlePrevious, // Swipe spre dreapta => mută la stânga
        preventScrollOnSwipe: true, // Evită scroll-ul în timpul swipe-ului
        trackMouse: true, // Permite simularea swipe-urilor și cu mouse-ul
    });

    useEffect(() => {
        return () => {
            if (product) {
                let updatedProducts = [Number(productId), ...props.recentViewedProducts.filter(id => id !== Number(productId))]
                if (updatedProducts.length > 12) {
                    updatedProducts.pop();
                }
                props.setRecentViewedProducts(updatedProducts)
            }
        };
    }, []);

    if (!product) {
        return (<h1 styles={styles.invalidProduct}>Invalid Product</h1>);
    }

    const handleThumbnailClick = (index) => {
        setCurrentImage(index);
    };

    const handlePowerChange = (event) => {
        setPriceIndex(Number(event.target.value));
    };

    const handleAddToCart = () => {
        props.setCart((prevCart) => {
            const existingItem = prevCart.find(
                (item) => item.id === product.id && item.priceIndex === priceIndex
            );

            if (existingItem) {
                return prevCart.map((item) =>
                    item.id === product.id && item.priceIndex === priceIndex
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                );
            }

            return [
                ...prevCart,
                {
                    id: product.id,
                    priceIndex: priceIndex,
                    quantity: 1
                }
            ];
        });

        navigate("/cart");
    }



    return (
        <>
            <div className={styles.container}>
                <TopBar name={product.name} activeCategory={props.activeCategory} setActiveCategory={props.setActiveCategory} setProducts={props.setProducts} />

                <div className={styles.productDetails}>
                    <div className={styles.imageGallery}>
                        <div {...handlers} className={styles.imageFrame}>
                            {(product.images.length > 1) && <button className={styles.arrowLeft} onClick={handlePrevious}>
                                <i className="fa-solid fa-circle-chevron-left"></i>
                            </button>}
                            <img
                                src={product.images[currentImage]}
                                alt={`TRIO Image ${currentImage + 1}`}
                                className={styles.mainImage}
                            />
                            {(product.images.length > 1) && <button className={styles.arrowRight} onClick={handleNext}>
                                <i className="fa-solid fa-circle-chevron-right"></i>
                            </button>}
                        </div>
                        <div className={styles.thumbnailContainer}>
                            {(product.images.length > 1) && product.images.map((src, index) => (
                                <img
                                    key={index}
                                    src={src}
                                    alt={`Thumbnail ${index + 1}`}
                                    className={`${styles.thumbnail} ${currentImage === index ? styles.activeThumbnail : ''
                                        }`}
                                    onClick={() => handleThumbnailClick(index)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className={styles.productInfo}>
                        <h1 className={styles.name}>{product.name}</h1>
                        <div className={styles.powerCost}>
                            <div className={styles.powerSelection}>

                                <span className={styles.power} >Putere</span>
                                <form>
                                    {product.prices.map((el, index) => (
                                        <label key={index}>
                                            <input
                                                type="radio"
                                                name="power"
                                                value={index}
                                                checked={priceIndex === index}
                                                onChange={handlePowerChange}
                                            />
                                            {el.power}
                                        </label>
                                    ))}
                                </form>
                            </div>
                            <div className={styles.priceContainer}>
                                <p className={styles.priceLabel}>Cost total:</p>
                                <p className={styles.price}>{product.prices[priceIndex].price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} RON</p>
                            </div>
                        </div>
                        <button className={styles.addToCartButton} onClick={handleAddToCart}>
                            <i className="fa-solid fa-cart-shopping" />
                            Adaugă în coș
                        </button>
                        <div className={styles.tva}>
                            <span >*Prețul afișat nu include TVA.</span>
                        </div>
                        <div className={styles.productDescription}>
                            <p className={styles.checkPrices}>{product.price_details && product.price_details}</p>
                            {product.short_description && (
                                <>
                                    <hr className={styles.separator} />
                                    <div className={styles.descriptionText}>{product.short_description}</div>
                                </>
                            )}
                            <hr className={styles.separator} />
                            <p className={styles.guaranteeText}>Garanție</p>
                        </div>
                    </div>
                </div>
                <div className={styles.features}>
                    {
                        product.parameters && product.parameters.map((el, index) => {
                            return <div key={index} className={styles.featureCard}>
                                <div className={styles.icon}>
                                    <i className={el.icon}></i>
                                </div>
                                <h3>{el.name}</h3>
                                <div className={styles.rating}>
                                    {
                                        [0, 1, 2, 3, 4].map((val) => val < el.stars ? '★' : '☆')
                                    }
                                </div>
                                <p>{el.details}</p>
                            </div>
                        })
                    }
                </div>
                {product.warranty_details &&
                    (<div className={styles.guaranteeBox}>
                        <div className={styles.guaranteeContent}>
                            <i className="fas fa-check-circle"></i>
                            <p>
                                Pentru a beneficia de garanția cazanelor
                                <span className={styles.productName}> {product.name}</span>, instalarea și reglarea arzătorului trebuie efectuată de către un reprezentant al firmei producătorului sau de către un specialist autorizat.
                            </p>
                        </div>
                    </div>)
                }
                <Tabs productId={product.id} tabsInfo={product.tabsInfo} />
            </div>
            <ClientBanner setActiveCategory={props.setActiveCategory} setProducts={props.setProducts} />
            <RecentProducts recentViewedProducts={props.recentViewedProducts} setCart={props.setCart} />
        </>

    );
};

export default ProductPage;
